<button 
  mat-flat-button 
  type="button" 
  class="btn"
  (click)="onClickBtn()"
  [disabled]="loader"
  [attr.aria-busy]="loader"
>
  <ng-container *ngIf="!loader; else loading">
    {{ name }}
  </ng-container>
  <ng-template #loading>
    <img src="assets/icons/btn-loader.svg" alt="" aria-hidden="true" class="spin" />
    <span class="sr-only">Loading, please wait…</span>
  </ng-template>
</button>